import { BENEFICIOS_SET } from "../ActionTypes";

const beneficios = (state, { type, payload }) => {
  switch (type) {
    case BENEFICIOS_SET:
      return {
        beneficios: {
          estado: payload,
        },
      };
    default:
      return state;
  }
};

export default beneficios;
